import {CommonModule} from "@angular/common";
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {IMenu} from 'src/app/core/models/menu.model';
import {MenuComponent} from '../menu/menu.component';

@Component({
  selector: 'app-bottom-navbar',
  standalone: true,
  imports: [
    CommonModule,
    MenuComponent
  ],
  templateUrl: './bottom-navbar.component.html',
  styleUrl: './bottom-navbar.component.css',
  host: {'class': 'flex bg-bluegray-50 border-top-1 surface-border justify-content-center'},
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomNavbarComponent {
  @Input() menu?: IMenu;
}
